import { Component, Input, Output, EventEmitter, HostListener } from '@angular/core';

@Component({
  selector: 'app-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss'],
  standalone: false
})
export class DropdownComponent {
  
  @Input() alignment: 'left' | 'right' = 'left';
  @Input() options: { icon: string, text: string, action: string, color?: string }[] = [];
  @Output() optionSelected = new EventEmitter<{ icon: string, text: string, action: string, color?: string }>();

  isOpen = false;

  toggle() {
    this.isOpen = !this.isOpen;
  }

  select(option: { icon: string, text: string, action: string, color?: string }) {
    this.optionSelected.emit(option);
    this.isOpen = false;
  }

  @HostListener('document:click', ['$event.target'])
  clickOutside(target: any) {
    if (!target.closest('.dropdown')) {
      this.isOpen = false;
    }
  }
}